// import fetch from 'axios';

// const BASE_API_URL = `${getBaseUrl()}/api/`;

// const Instance = axios.create({
//     baseURL: BASE_API_URL,
//     timeout: 1000000,
// });

import fetch from 'isomorphic-fetch';

const methods = [
  'get',
  'post',
  'put',
  'delete',
];

class fetchLocal {
  constructor( options = {} ) {
    this.options = options;
    
    if ( !options.restURL )
    throw new Error('restURL option is required');
    
    if ( !options.restNonce )
    throw new Error('restNonce option is required');
    
    methods.forEach(method => {
      this[method] = this._setup(method);
    });
  }
  
  _setup( method ) {
    return (endpoint = '/', data = false) => {
      let fetchObject = {
        credentials: 'same-origin',
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-WP-Nonce': this.options.restNonce,
        }
      };
      
      if ( data ) {
        fetchObject.body = JSON.stringify(data);
      }
      
      return fetch(this.options.restURL + endpoint, fetchObject)
      .then(response => {
        return response.json().then(json => {
          return response.ok ? json : Promise.reject(json);
        });
      });
    }
  }
}
export default fetchLocal;